module.exports = __webpack_public_path__ + "img/bottom_swhz.adcc74f7.png";